export const BoxStyle = () => ({
  paddingRight: "1rem",
  "&:last-child": {
    paddingRight: "0rem",
  },
});

export const RadioGroupStyle = () => ({
  display: "flex",
  flexDirection: "row",
});

export const MemberDetailsHeading = () => ({
  padding: "0.5rem 0 1.2rem 0",
});

export const RadioGroupContainer = () => ({
  paddingBottom: "1rem",
});

export const HelperTextStyle = () => ({
  ml: "1rem",
});
